import _ from 'lodash';
import emiter, { _EVENTS } from '../../events';
import { _APIS } from 'apis';
import request from 'request';
import {Modal, message} from "antd";
import { DEFAULT_PAGE_INFO } from "../../consts";
import { debounce } from 'lodash';


export const useSupplierEntry = () => {

  const getMinCityList = (params:any) => request.get(_APIS.SUPPLIER_ENTRY.MIN_CITY_LIST, {params});

  const getCityList = () => request.get(_APIS.PRODUCT_PRICE.SERVICE_POLICY.CITY_LIST, {});

  const getContract = () => request.get(_APIS.SUPPLIER_ENTRY.GET_CONTRACT);

  const verifyCode = () => request.get(_APIS.SUPPLIER_ENTRY.GET_VERIFY_CODE);

  const getSupplierInfo = () => request.get(_APIS.SUPPLIER_ENTRY.SUPPLIER_INFO);

  const supplierEnter = () => request.get(_APIS.SUPPLIER_ENTRY.ENTER);

  const operationScaleSave = (params: any) => request.post(_APIS.SUPPLIER_ENTRY.OPERATION_SCALE_SAVE, params);

  const confirmSign = (params:any) => request.get(_APIS.SUPPLIER_ENTRY.CONFIRM_SIGN_CONTRACT,{params})

  const getVerifyCode = () => {
      verifyCode().then((res) => {
        res.data ? message.success('验证码已发送') : message.error('验证码发送失败')
      }).catch((err) => {
        message.error('验证码发送失败')
      })
  }

  const getBankList = (params:any) => request.get(_APIS.SUPPLIER_ENTRY.BANK_LIST, { params });
  const getBankChannelList = (params:any) => request.get(_APIS.SUPPLIER_ENTRY.BANK_CHANEL_LIST, {
    headers: {
      "didi-header-rid": "z18394acd7eb7d12ae380419d9569598"
    },
    params
  });
  const getBranchBankList = (params:any) => request.get(_APIS.SUPPLIER_ENTRY.BRANCH_BANK_LIST, { params });
  const agreementSign = (params:any) => request.post(_APIS.SUPPLIER_ENTRY.AGREEMENT_SIGN, params);
  const basicSave = (params:any) => request.post(_APIS.SUPPLIER_ENTRY.BASIC_SAVE, params);
  const merchantSettle = (params?:any) => request.post(_APIS.SUPPLIER_ENTRY.MERCHANT_SETTLE, params);
  const getAuthUrl = (params:any) => request.get(_APIS.SUPPLIER_ENTRY.AUTH_URL, { params });
  const getSealAuthUrl = (params:any) => request.get(_APIS.SUPPLIER_ENTRY.SEAL_AUTH_URL, { params });
  const getAuthStatus = (params:any) => request.get(_APIS.SUPPLIER_ENTRY.AUTH_STATUS, { params });



  return {
    getMinCityList,
    getCityList,
    getContract,
    getVerifyCode,
    confirmSign,
    getBankList,
    getBranchBankList,
    agreementSign,
    basicSave,
    getSupplierInfo,
    getBankChannelList,
    getAuthUrl,
    getSealAuthUrl,
    getAuthStatus,
    operationScaleSave,
    supplierEnter,
    merchantSettle,
  }
}
